<div class=" px-15">
    <section id="overall-summaries" class="scrolld-parent">
        <!-- fulfilled vs booked in real time, Pending, New / Proposed Appointments  -->
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15"> Summaries </div>
                    <div>
                        <select class="header-middle" name="" id="" mat-select [formControl]="timeRange">
                            @for(option of ['Today', 'This Week', 'This month']; track $index){
                            <option value="{{option}}">
                                {{option}}
                            </option>
                            }

                        </select>
                    </div>

                </div>
                <div class="subtitle">


                </div>
            </div>


            <div class="controls g-just-flex gap-15" [scrolld]="'card'">
                <div class=" rounded-icon-wrapper prev-btn">
                    <mat-icon>
                        chevron_left
                    </mat-icon>

                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>
                        chevron_right
                    </mat-icon>

                </div>

            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="card appointment-card" (click)="manageSelectedAppointments()">
                    <select class="absolute-top" name="" id="" mat-select [formControl]="timeRange" (click)="$event.stopPropagation()">

                        @for(option of ['Today', 'This Week', 'This month']; track $index){
                        <option value="{{option}}">
                            {{option}}
                        </option>
                        }
                    </select>

                    <div class="card-top g-just-flex space-between gap-30
                     ">
                        <div class="left g-just-flex gap-8
                        justify-content-start
                   ">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>people</mat-icon>
                                <div class="grey round newbg">
                                    <mat-icon>

                                        auto_awesome

                                    </mat-icon>
                                </div>
                            </div>

                            <div class="top-text subtitle-text-color-2  ">
                                Appointments
                            </div>


                        </div>
                        <div class="right">
                            <mat-icon matTooltip="
                            The number of fulfilled versus 'no-show'
                            appointments so far for today
                            ">
                                light_bulb
                            </mat-icon>


                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="g-just-flex space-between">
                            <div class="right large-words g-just-flex
                        justify-content-start gap-8
                        ">
                                <div class="large-words">
                                    @if(metricsLoading$ | async){
                                    <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24">
                                    </mat-progress-spinner>
                                    } @else {
                                    {{ (appointmentDisplayValue$ | async) || 0 }}
                                    }
                                </div>

                            </div>

                            <div class="left">
                                <select name="" id="" value="Booked" mat-select [formControl]="todayAppointSelect" (click)="$event.stopPropagation()">
                                    @for(option of ['Fulfilled', 'No-Show', 'Remaining', 'Booked']; track $index;){
                                    <option value="{{option}}">
                                        {{option}}
                                    </option>
                                    }
                                </select>

                            </div>

                        </div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2
                        justify-content-start
                        ">
                            @if(metricsLoading$ | async){
                            <mat-progress-spinner class="card-loader small" mode="indeterminate" diameter="16">
                            </mat-progress-spinner>
                            } @else {
                            {{ (appointmentDisplayValue$ | async) || 0 }} out of {{ (metrics$ |
                            async)?.appointments?.total || 0 }} total
                            }
                        </div>
                        <div class="right">



                        </div>
                    </div>
                </div>


                <div class="card appointment-card">
                    <select class="absolute-top" name="" id="" mat-select [formControl]="timeRange">

                        @for(option of ['Today', 'This Week', 'This month']; track $index){
                        <option value="{{option}}">
                            {{option}}
                        </option>
                        }
                    </select>

                    <div class="card-top g-just-flex space-between gap-30
                     ">
                        <div class="left g-just-flex gap-8
                        justify-content-start
                   ">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>group</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2  ">
                                Encounter
                            </div>


                        </div>
                        <div class="right">
                            <mat-icon matTooltip="
                            The number of fulfilled versus 'no-show'
                            appointments so far for today
                            ">
                                light_bulb
                            </mat-icon>


                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="g-just-flex space-between">
                            <div class="right large-words">
                                @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24">
                                </mat-progress-spinner>
                                } @else {
                                {{ (encounterDisplayValue$ | async) || 0 }}
                                }
                            </div>
                            <div class="left">
                                <select name="" id="" mat-select [formControl]="encounterDropDown">
                                    @for(option of ['All','In-Patient', 'Out-Patient', 'Emergency', 'Virtual', 'Home'];
                                    track
                                    $index;){
                                    <option value="{{option}}">
                                        {{option}}
                                    </option>
                                    }
                                </select>

                            </div>

                        </div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2
                        justify-content-start
                        ">
                            @if(metricsLoading$ | async){
                            <mat-progress-spinner class="card-loader small" mode="indeterminate" diameter="16">
                            </mat-progress-spinner>
                            } @else {
                            {{ (encounterDisplayValue$ | async) || 0 }} out of a total {{ (metrics$ |
                            async)?.encounters?.total || 0 }}
                            }
                        </div>
                        <div class="right">



                        </div>
                    </div>
                </div>


                <div class="card appointment-card">
                    <select class="absolute-top" name="" id="" mat-select [formControl]="timeRange">

                        @for(option of ['Today', 'This Week', 'This month']; track $index){
                        <option value="{{option}}">
                            {{option}}
                        </option>
                        }
                    </select>

                    <div class="card-top g-just-flex space-between gap-30
                     ">
                        <div class="left g-just-flex gap-8
                        justify-content-start
                   ">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>person</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2  ">
                                New Patients
                            </div>


                        </div>
                        <div class="right">
                            <mat-icon matTooltip="
                            The number of fulfilled versus 'no-show'
                            appointments so far for today
                            ">
                                light_bulb
                            </mat-icon>


                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="g-just-flex space-between">
                            <div class="right large-words">
                                @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24">
                                </mat-progress-spinner>
                                } @else {
                                {{ (patientDisplayValue$ | async) || 0 }}
                                }
                            </div>
                            <div class="left">
                                <select name="" id="" mat-select [formControl]="patientsDropDown">
                                    @for(option of ['All'];
                                    track
                                    $index;){
                                    <option value="{{option}}">
                                        {{option}}
                                    </option>
                                    }
                                </select>

                            </div>

                        </div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2
                        justify-content-start
                        ">
                            @if(metricsLoading$ | async){
                            <mat-progress-spinner class="card-loader small" mode="indeterminate" diameter="16">
                            </mat-progress-spinner>
                            } @else {
                            {{ (patientDisplayValue$ | async) || 0 }} Registered Patients
                            }
                        </div>
                        <div class="right">



                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <section id="appointments-summaries" class="scrolld-parent">
        <!-- fulfilled vs booked in real time, Pending, New / Proposed Appointments  -->
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title g-just-flex">
                    <div class="me-15"> Quick Actions </div>



                </div>
                <div class="subtitle">


                </div>
            </div>


            <div class="controls g-just-flex gap-15" [scrolld]="'action-button'">
                <div class=" rounded-icon-wrapper prev-btn">
                    <mat-icon>
                        chevron_left
                    </mat-icon>

                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>
                        chevron_right
                    </mat-icon>

                </div>

            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="action-button" (click)="addAvailableServices()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>science</mat-icon>
                    </div>

                    <span>Add Available Services</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="openHealthcareServiceDialog()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>video_chat</mat-icon>
                    </div>

                    <span>Add Telemedicine Services</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

                <div class="action-button" (click)="manageSelectedAppointments()">
                    <div class="rounded-icon-wrapper">
                        <mat-icon>event_note</mat-icon>
                    </div>

                    <span>Manage Appointments</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>

            </div>
        </div>
    </section>



    <section id="appointments-summaries" class="scrolld-parent">
        <!-- fulfilled vs booked in real time, Pending, New / Proposed Appointments  -->
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">
                    Appointments
                </div>
                <div class="subtitle">


                </div>
            </div>
            <div class="controls g-just-flex gap-15" [scrolld]="'card'">
                <div class=" rounded-icon-wrapper prev-btn">
                    <mat-icon>
                        chevron_left
                    </mat-icon>

                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>
                        chevron_right
                    </mat-icon>

                </div>

            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-20">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <!-- New Requests Card -->
                <div class="card appointment-card" (click)="manageCurrentAppointmentStatus('proposed', 'active')">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="grey round newbg">
                                <mat-icon>auto_awesome</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">New Requests</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Appointments currently in 'Proposed' status - awaiting initial administrative action">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">
                            @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24"></mat-progress-spinner>
                            } @else {
                                {{newRequests$ | async}}
                            }
                        </div>
                    </div>
                    <div class="card-bottom"></div>
                </div>

                <!-- Awaiting Approval Card -->
                <div class="card appointment-card" (click)="manageCurrentAppointmentStatus('pending', 'active')">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="grey round yellowbg">
                                <mat-icon>hourglass_empty</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Awaiting Approval</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Appointments assigned to a doctor but awaiting their final acceptance (Pending status)">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">
                            @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24"></mat-progress-spinner>
                            } @else {
                                {{pendingAppts$ | async}}
                            }
                        </div>
                    </div>
                    <div class="card-bottom"></div>
                </div>

                <!-- Confirmed Card -->
                <div class="card appointment-card" (click)="manageCurrentAppointmentStatus('booked', 'active')">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="grey round greenbg">
                                <mat-icon>check_circle</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Confirmed</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Appointments fully accepted by all participants and scheduled (Booked status)">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">
                            @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24"></mat-progress-spinner>
                            } @else {
                                {{confirmedAppts$ | async}}
                            }
                        </div>
                    </div>
                    <div class="card-bottom"></div>
                </div>

                <!-- Waitlist Card -->
                <div class="card appointment-card" (click)="manageCurrentAppointmentStatus('waitlist', 'active')">
                    <div class="card-top g-just-flex space-between gap-30">
                        <div class="left g-just-flex gap-8 justify-content-start">
                            <div class="grey round purplebg">
                                <mat-icon>format_list_bulleted</mat-icon>
                            </div>
                            <div class="top-text subtitle-text-color-2">Waitlisted</div>
                        </div>
                        <div class="right">
                            <mat-icon matTooltip="Appointments placed on a waitlist to be scheduled when a slot becomes available">light_bulb</mat-icon>
                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="large-words">
                            @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24"></mat-progress-spinner>
                            } @else {
                                {{waitlistAppts$ | async}}
                            }
                        </div>
                    </div>
                    <div class="card-bottom"></div>
                </div>

            </div>
        </div>

    </section>

    <section id="resources-summaries" class="scrolld-parent">
        <!-- fulfilled vs booked in real time, Pending, New / Proposed Appointments  -->
        <div class="secction-header g-just-flex flex-between">
            <div class="words g-just-flex.flex-column.gap-12">
                <div class="title">
                    Resources
                </div>
                <div class="subtitle">


                </div>
            </div>


            <div class="controls g-just-flex gap-15">
                <div class=" rounded-icon-wrapper prev-btn" [scrolld]="'card'">
                    <mat-icon>
                        chevron_left
                    </mat-icon>

                </div>
                <div class="rounded-icon-wrapper next-btn">
                    <mat-icon>
                        chevron_right
                    </mat-icon>

                </div>

            </div>
        </div>

        <div class="section-wrapper scrollable-container pt-30">
            <div class="overflow-container g-just-flex justify-content-start gap-30">
                <div class="card appointment-card">


                    <div class="card-top g-just-flex space-between gap-30
                     ">
                        <div class="left g-just-flex gap-8
                        justify-content-start
                   ">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>

                                    hotel

                                </mat-icon>
                            </div>
                            <div class=" top-text subtitle-text-color-2 ">
                                Beds Available
                            </div>


                        </div>
                        <div class=" right">
                            <mat-icon matTooltip="
                            The number of unoccupied beds currently available
                            ">
                                light_bulb
                            </mat-icon>


                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="g-just-flex space-between">
                            <div class="right large-words">
                                @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24">
                                </mat-progress-spinner>
                                } @else {
                                {{bedsAvailable$ | async}}
                                }
                            </div>
                            <div class="left">


                            </div>

                        </div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2
                        justify-content-start
                        ">
                            @if(metricsLoading$ | async){
                            <mat-progress-spinner class="card-loader small" mode="indeterminate" diameter="16">
                            </mat-progress-spinner>
                            } @else {
                            {{bedsAvailable$ | async}} out of {{bedsTotal$ | async}} total
                            }


                        </div>
                        <div class="right">



                        </div>
                    </div>
                </div>

                <div class="card appointment-card">


                    <div class="card-top g-just-flex space-between gap-30
                     ">
                        <div class="left g-just-flex gap-8
                        justify-content-start
                   ">
                            <div class="rounded-icon-wrapper">
                                <mat-icon>

                                    medications

                                </mat-icon>
                            </div>
                            <div class=" top-text subtitle-text-color-2 ">
                                Out-of-Stock Medicines
                            </div>


                        </div>
                        <div class=" right">
                            <mat-icon matTooltip="
                            Medications with zero remaining stock
                            ">
                                light_bulb
                            </mat-icon>


                        </div>
                    </div>
                    <div class="card-middle">
                        <div class="g-just-flex space-between">
                            <div class="right large-words">
                                @if(metricsLoading$ | async){
                                <mat-progress-spinner class="card-loader" mode="indeterminate" diameter="24">
                                </mat-progress-spinner>
                                } @else {
                                {{outOfStockMedicines$ | async}}
                                }
                            </div>
                            <div class="left">


                            </div>

                        </div>
                    </div>
                    <div class="card-bottom g-just-flex space-between gap-12">
                        <div class="left g-just-flex gap-10 subtitle-text-color-2
                        justify-content-start
                        ">
                            @if(metricsLoading$ | async){
                            <mat-progress-spinner class="card-loader small" mode="indeterminate" diameter="16">
                            </mat-progress-spinner>
                            } @else {
                            {{outOfStockMedicines$ | async}} out of {{totalMedicines$ | async}} total
                            }


                        </div>
                        <div class="right">



                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <app-upcoming-activities></app-upcoming-activities>
</div>
